import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { liveQuery } from 'dexie';
import { appDb } from 'dexie/app.db';
import { from, catchError, throwError, switchMap } from 'rxjs';
import { DBService } from './db.service';
import { FileService } from './file.service';
import { ErrorLevelApiService } from './api/error-level-api.service';

@Injectable({
  providedIn: 'root',
})
export class ErrorLevelService {
  protected dbService = inject(DBService);
  protected fileService = inject(FileService);
  protected errorLevelApiService = inject(ErrorLevelApiService);

  getList(filter?: any) {
    let dbQuery = appDb.errorLevel.where('isDeleted').equals(0);
    if (filter?.name) {
      dbQuery = dbQuery.and((item) =>
        item.name.toLowerCase().startsWith(filter.name.toLowerCase())
      );
    }
    if (filter?.type) {
      dbQuery = dbQuery.and((item) => item.type === filter.type);
    }
    return from(liveQuery(() => dbQuery.sortBy('order')));
  }

  get(id) {
    return from(liveQuery(() => appDb.errorLevel.get(id)));
  }

  getByIds(ids: Array<string>) {
    return from(
      liveQuery(() => appDb.errorLevel.where('id').anyOf(ids).toArray())
    );
  }

  create(data) {
    return this.errorLevelApiService.create(data).pipe(
      catchError((err: HttpErrorResponse) => {
        if (!navigator.onLine) {
          return this.dbService.createRow(appDb.errorLevel, {
            ...data,
            isSynced: 0,
            isDeleted: 0,
          });
        }
        return throwError(() => err);
      })
    );
  }

  update(id, data) {
    return this.errorLevelApiService
      .update(id, { id, name: data.name, order: data.order, color: data.color })
      .pipe(
        catchError((err: HttpErrorResponse) => {
          if (!navigator.onLine) {
            return this.dbService.updateRow(appDb.errorLevel, {
              ...data,
              isSynced: 0,
              isDeleted: 0,
            });
          }
          return throwError(() => err);
        })
      );
  }

  delete(id: string) {
    return this.errorLevelApiService.delete(id).pipe(
      switchMap((res: any) => this.dbService.deleteRow(appDb.errorLevel, id)),
      catchError((err: HttpErrorResponse) => {
        if (!navigator.onLine) {
          return this.dbService.updateRow(appDb.errorLevel, {
            id,
            isDeleted: 1,
            isSynced: 0,
          });
        }
        return throwError(err);
      })
    );
  }
  getNotSyncedItems() {
    return from(appDb.errorLevel.where('isSynced').equals(0).toArray());
  }

  getNotSyncedItemsCount() {
    return from(
      liveQuery(() => appDb.errorLevel.where('isSynced').equals(0).count())
    );
  }
  bulkUpdateLocal(items) {
    return from(appDb.errorLevel.bulkPut(items));
  }
}
